import React, { useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { Privacy_PolicyRead } from "../../Redux/Slices/PrivacyPolicy/PrivacyPolicyRead";
import './PrivacyPolicy.css'; 

const PrivacyPolicy: React.FC = () => {
  const dispatch = useAppDispatch();
  const listPrivacyPolicy = useAppSelector((state) => state.listPrivacyPolicy?.data);

  console.log(listPrivacyPolicy, "list");

  useEffect(() => {
    dispatch(Privacy_PolicyRead());
  }, [dispatch]);

  return (
    <Box className="privacy-policy-wrapper">
      <Container className="privacy-policy-container">
        {/* Header Section */}
        <Box className="privacy-policy-header">
          <Typography 
            variant="h2" 
            className="privacy-policy-title"
          >
            {listPrivacyPolicy?.data.template_name || 'Privacy Policy'}
          </Typography>
          <Typography 
            variant="h6" 
            className="privacy-policy-date"
          >
            Last updated: {new Date().toLocaleDateString("en-GB", {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })}
          </Typography>
        </Box>

        {/* Content Section */}
        <Box className="privacy-policy-content-wrapper">
          <Box
            className="privacy-policy-content"
            dangerouslySetInnerHTML={{
              __html: listPrivacyPolicy?.data.template_content || "",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;